import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { IAMService } from 'app/auth';
import { GoogleAnalyticsService, LoadingService, TermsAndConditionService } from 'app/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  // template variables
  public loading: Observable<boolean>;
  public fileUrl: string;
  public promoText: string;
  public promoHeaderText: string;
  public showPromoBanner: boolean;

  // Monitoring & CARE package banner
  public showMonitoringBanner = true;

  //promotions switched off now
  private readonly isPromoActive: boolean = false;

  constructor(
    private gaService: GoogleAnalyticsService,
    private loadingService: LoadingService,
    @Inject(LOCALE_ID) public locale: string,
    private termsAndConditionService: TermsAndConditionService,
    private iamService: IAMService
  ) {
    // register to loading event
    this.loading = this.loadingService.isLoading;

    // initialize the google analytics functionality
    this.gaService.initialize();

    // get the terms and condition pdf once
    this.termsAndConditionService.getTermsAndCondition().subscribe((test) => {
      this.fileUrl = URL.createObjectURL(test);
    });
    // Set monitoring banner text based on locale
    this.setMonitoringBannerText();
  }

  private setMonitoringBannerText(): void {
    if (this.locale === 'de') {
      this.promoHeaderText = 'Wichtiger Hinweis';
      this.promoText =
        'Bitte beachten Sie: Ab dem 1. Mai werden die Preise für Pumpen und Ersatzteile angepasst. ' +
        'Dies gilt für alle ab dem 1. Mai ausgestellten Angebote und wirkt sich auch auf die Gültigkeit der aktuellen Angebote aus.';
    } else {
      this.promoHeaderText = 'Important Notice';
      this.promoText =
        'Please note: Effective May 1st prices for pumps and spare parts will be adjusted. ' +
        'This will apply to all quotations issued from May 1st and will also affect the validity of current quotations.';
    }
  }

  public ngOnInit(): void {
    if (this.isPromoActive) {
      // Change back when the promo banner for monitoring & care package is to be activated in production
      this.iamService.getCustomerSalesInfo().subscribe((res) => {
        if (res?.SalesOrganizationId === '1' || res?.SalesOrganizationId === '5') {
          this.showPromoBanner = true;
        } else {
          this.showPromoBanner = false;
        }
      });
    }
  }

  /**
   * Shows the terms and condition pdf in a new tab
   */
  public showTermsAndCondition(): void {
    this.termsAndConditionService.openTermsAndCondtion(this.fileUrl);
  }
}
